import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const IntegrationsIcon = ({ color })=>/*#__PURE__*/ _jsxs("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsxs("g", {
                clipPath: "url(#clip0_589_3100)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M3.84863 12.293L8.18694 16.5269C8.84001 17.1643 9.88612 17.1516 10.5235 16.4985L13.2608 13.6938L15.9981 10.889C16.6355 10.2359 16.6227 9.18982 15.9697 8.55246L11.6314 4.31848",
                        stroke: color || "#676879",
                        strokeWidth: "1.25"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M2.65137 13.5205L12.8288 3.09233",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M6.5918 2.11961C6.34477 1.87852 5.94908 1.88333 5.70799 2.13036C5.4669 2.37739 5.47171 2.77309 5.71874 3.01418L6.5918 2.11961ZM5.71874 3.01418L9.39928 6.60621L10.2723 5.71163L6.5918 2.11961L5.71874 3.01418Z",
                        fill: color || "#676879"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M12.9609 14.0007L16.6415 17.5928",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M2.40137 6.41404C2.15434 6.17295 1.75865 6.17777 1.51756 6.4248C1.27647 6.67183 1.28128 7.06753 1.52831 7.30862L2.40137 6.41404ZM1.52831 7.30862L5.20885 10.9006L6.08191 10.0061L2.40137 6.41404L1.52831 7.30862Z",
                        fill: color || "#676879"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_589_3100",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "20",
                        height: "20",
                        fill: "white"
                    })
                })
            })
        ]
    });
